// extracted by mini-css-extract-plugin
module.exports = {"safeAppTagContainer":"styles_safeAppTagContainer__X3UA8","safeAppTagLabel":"styles_safeAppTagLabel__SrQMw"};